<template>
    <div class="background">
        <div style="text-align:center; margin: 5rem 0;">
            <van-field v-model="query.phone" type="number" label="手机号" placeholder="请输入新用户手机号" class="input" />
            <van-button type="warning" size="normal" round @click="ccbJobOrderDeclare" class="buyButton">点击下载建行生活APP</van-button>
        </div>
        <van-dialog v-model="showDialog" title="提示" show-cancel-button @confirm="confirmJump">
            <div style="margin: 2rem 0;">
                报单失败，是否确定要前往下载页面？
            </div>
        </van-dialog>
    </div>
</template>

<script>
    import mainAPI from '@/api/main';
    import pvuvAPI from '@/api/pvuv';

    export default {
        data() {
            return {
                query: {
                    traderId: this.$route.query.traderId,
                    jobLinkUpPid: this.$route.query.pid,
                    phone: '',
                },
                showDialog: false,
            }
        },
        methods: {
            ccbJobOrderDeclare() {
                if (!this.$myUtil.mobile(this.query.phone)) {
                    this.$toast("请输入正确的手机号");
                    return;
                }
                mainAPI.ccbJobOrderDeclare(this.query).then(() => {
                    window.location.href = 'http://appurl.me/79819187384';
                }).catch(() => {
                    this.showDialog = true;
                });
            },
            confirmJump() {
                window.location.href = 'http://appurl.me/79819187384';
            },
        },
        created() {
        },
        mounted() {
            pvuvAPI.addPv("jobDeclare/CCBDeclare", this.query.traderId).then((result) => {
            });
        }
    }

</script>

<style lang="scss" scoped>

    .background {
        background-image: url('http://jho2o.oss-cn-beijing.aliyuncs.com/test/2NkmgSAt.png');
        background-size: 100% 100%;
        height: 68rem;
        padding-top: 20rem;
        text-align: center;
    }

    .input {
        height: 5rem;
        font-size: 1.5rem;
        margin: 7rem 0;
    }

    .buyButton {
        width: 75%;
        font-size: 1.5rem;
        color: #FFFFFF;
    }

</style>
